<template>
  <div class="w-100 w-md-75 mb-10">
    <v-card>
      <v-form ref="form" @submit.prevent="updateProduct" class="pa-4 px-4">
        <v-row>
          <v-col class="pr-md-24">
            <div class="text-left mb-6">
              <h4 class="back--text gotham-book">General Information</h4>
            </div>
            <v-row class="mb-2">
              <v-col cols="6" class="py-0">
                <v-text-field
                  :rules="nameRules"
                  label="Name"
                  outlined
                  v-model="product.name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-autocomplete
                  v-model="product.productBrandId"
                  :items="brands"
                  :rules="brandRules"
                  outlined
                  label="Select Brand"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-autocomplete
                  v-model="product.productSubcategories"
                  :items="subcategories"
                  outlined
                  multiple
                  label="Select Subcategories"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  :rules="manufactureRules"
                  label="Manufacturer"
                  outlined
                  v-model="product.manufacturerId"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-6 text-left">
              <h4 class="black--text gotham-book">Images</h4>
            </div>
            <v-row class="mb-8">
              <v-col
                cols="12"
                md="12"
                v-for="(image, index) in product.images"
                :key="index"
              >
                <image-picker
                  v-model="product.images[index].imageUrl"
                  :uploaded="product.images[index].imageUrl !== null"
                  @reset="product.images[index].imageUrl = null"
                  @delete-item="deleteImage(image.id)"
                  @input="editImage(image, $event)"
                >
                  <div slot="activator" class="cursor-pointer w-100 h-100">
                    <img
                      :src="image.imageUrl"
                      alt="avatar"
                      width="100%"
                      height="100%"
                    />
                  </div>
                </image-picker>
              </v-col>
              <v-col cols="12" md="12">
                <image-picker @input="addImage"> </image-picker>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-6 text-left">
              <h4 class="black--text gotham-book">Specifications and Price</h4>
            </div>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Price"
                  type="number"
                  :rules="amountRules"
                  required
                  outlined
                  v-model="product.amount"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Size"
                  :rules="sizeRules"
                  outlined
                  v-model="product.size"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  type="number"
                  label="Quantity"
                  :rules="quantityRules"
                  outlined
                  v-model="product.quantity"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Color"
                  :rules="colorRules"
                  outlined
                  v-model="product.colour"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-6 text-left">
              <h4 class="black--text gotham-book">Product status</h4>
            </div>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="product.isBestSeller"
                  label="Is best seller"
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-autocomplete
                  v-model="product.status"
                  :items="['sold', 'active', 'available']"
                  outlined
                  label="Select Status"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="product.surgeriesOnly"
                  label="Surgeries only"
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="product.prescriptionOnly"
                  label="Prescription only"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-6 text-left">
              <h4 class="black--text gotham-book">Description</h4>
            </div>
            <v-row>
              <v-col>
                <v-textarea
                  name="input-7-1"
                  label="Describe your product here..."
                  outlined
                  :rules="descriptionRules"
                  rows="3"
                  v-model="product.description"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-6 text-left">
              <h4 class="black--text gotham-book">Shipment Profile</h4>
            </div>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="product.shipmentProfileId"
                  :items="shipmentProfiles"
                  outlined
                  label="Select Shipment Profile"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="d-flex justify-start">
          <v-btn type="submit" color="accent" class="font-bold"
            >Update Product</v-btn
          >
        </div>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  props: ["id"],
  data: () => ({
    saving: false,
    saved: false,
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length >= 5) || "Name must be at least 5 characters",
      v =>
        (v && v.length <= 250) || "Name must be less than than 250 characters"
    ],
    brandRules: [v => !!v || "Brand is required"],
    quantityRules: [
      v => !!v || "Quantity is required",
      v => (v && v.length >= 1) || "Quantity must be at least 1 characters",
      v =>
        (v && v.length <= 50) || "Quantity must be less than than 50 characters"
    ],
    sizeRules: [
      v => !!v || "Size is required",
      v => (v && v.length >= 1) || "Size must be at least 1",
      v => (v && v.length <= 50) || "Size must be less than than 50"
    ],
    amountRules: [
      v => !!v || "Amount is required",
      v =>
        /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
        "Amount must be decimal number with two decimal number maximum",
      v => (v && v >= 1) || "Amount must be at least 1",
      v => (v && v <= 99999.99) || "Amount must be less then 99999.99"
    ],
    colorRules: [
      v => !!v || "Color is required",
      v => (v && v.length >= 1) || "Color must be at least 1 characters",
      v => (v && v.length <= 50) || "Color must be less than than 50 characters"
    ],
    supplierRules: [v => !!v || "Supplier is required"],
    descriptionRules: [
      v => !!v || "Description is required",
      v =>
        (v && v.length >= 25) || "Description must be at least 25 characters",
      v =>
        (v && v.length <= 65535) ||
        "Description must be less than than 65,535 characters"
    ],
    manufactureRules: [
      v => !!v || "manufacture is required",
      v => (v && v.length >= 5) || "manufacture must be at least 5 characters",
      v =>
        (v && v.length <= 25) ||
        "manufacture must be less than than 25 characters"
    ]
  }),
  components: {
    ImagePicker
  },
  mounted() {
    this.$store.dispatch("brands/LOAD_BRANDS", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("subcategories/LOAD_SUBCATEGORIES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("products/LOAD_PRODUCT", {
      productId: this.id
    });
    this.$store.dispatch("shipmentprofiles/LOAD_SHIPMENT_PROFILES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      product: state => state.products.product,
      brands: state => state.brands.brands,
      subcategories: state => state.subcategories.subcategories,
      shipmentProfiles: state => state.shipmentprofiles.shipmentProfiles
    })
  },
  methods: {
    async updateProduct() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating product...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("products/UPDATE_PRODUCT", this.product);
      }
    },
    async addImage(image) {
      this.$swal({
        title: "Adding product image...",
        html: "this will only take a moment...",
        icon: "info",
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("productimages/ADD_PRODUCT_IMAGE", {
        image: image,
        productId: this.product.id
      });
      this.$swal.close();
      this.$swal({
        title: "Success",
        html: "Product Image has been added",
        icon: "info"
      });
      await this.$store.dispatch("products/LOAD_PRODUCT", {
        productId: this.id
      });
    },
    async editImage(image, event) {
      image.imageUrl = event;
      this.$swal({
        title: "Updating product image...",
        html: "this will only take a moment...",
        icon: "info",
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("productimages/UPDATE_PRODUCT_IMAGE", {
        productId: this.id,
        image: event,
        id: image.id
      });
      this.$swal.close();
      this.$swal({
        title: "Success",
        html: "Image has been updated",
        icon: "info"
      });
    },
    async deleteImage(id) {
      this.$swal({
        title: "Deleting product image...",
        html: "this will only take a moment...",
        icon: "info",
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("productimages/DELETE_PRODUCT_IMAGE", {
        id: id
      });
      this.$swal.close();
      this.$swal({
        title: "Success",
        html: "Image has been deleted",
        icon: "info"
      });
      await this.$store.dispatch("products/LOAD_PRODUCT", {
        productId: this.id
      });
    }
  }
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
.relative {
  position: relative;
}
.delete-image-btn {
  bottom: 30px;
  right: 30px;
}
</style>
